module.exports = "<div class=\"form-group {{class}}\">\n\t<label *ngIf=\"label\" class=\"control-label\">\n\t\t{{label}}\n\t\t<span *ngIf=\"required\" class=\"orange\">*</span>\n\t\t<small *ngIf=\"tips\" class=\"text-warning\">{{tips}}</small>\n\t</label>\n\t<div>\n\t\t<ng-content></ng-content>\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/widgets/form-group/form-group.html
// module id = 531
// module chunks = 0